import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import {
	InteractivePropType,
	InteractiveResultPropType,
	VariantPropType
} from 'propTypes/common';

// eslint-disable-next-line import/no-cycle
import QuestionsList from '../components/QuestionsList';
// import Results from '../components/Results';
import SectionResults from '../components/SectionResults';

import styles from './styles.module.scss';

const TestWithVariants = ({
	interactive,
	selectedVariants,
	restartTest,
	selectVariant,
	showQuestions,
	showResult,
	resultMetadata,
	score,
	finishTest,
	isTestFinished,
	questions,
	questionsAmount
}) => {
	const { type } = interactive;
	const mode = interactive?.mode || 'list';
	const contentContainerRef = useRef(null);

	const isSliderLayout = mode === 'slider' || interactive?.type === 'testTree';

	return (
		<div className={styles.Container} ref={contentContainerRef}>
			{showQuestions && (
				<QuestionsList
					{...{
						contentContainerRef,
						finishTest,
						isSliderLayout,
						isTestFinished,
						mode,
						questions,
						selectVariant,
						selectedVariants,
						type
					}}
				/>
			)}

			{showResult && (
				<SectionResults
					{...{
						score,
						questionsAmount,
						resultMetadata,
						restartTest
					}}
				/>
			)}
		</div>
	);
};
TestWithVariants.propTypes = {
	interactive: InteractivePropType,
	score: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	selectedVariants: PropTypes.arrayOf(
		PropTypes.oneOfType([VariantPropType, PropTypes.object])
	),
	restartTest: PropTypes.func,
	selectVariant: PropTypes.func,
	showQuestions: PropTypes.bool,
	showResult: PropTypes.bool,
	resultMetadata: InteractiveResultPropType,
	finishTest: PropTypes.func,
	isTestFinished: PropTypes.bool,
	choiceLevel: PropTypes.func,
	questions: PropTypes.array,
	questionsAmount: PropTypes.number
};

export default TestWithVariants;
